var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_566",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_52_566",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAASZSURBVHic7Z3dcds4FIUPdvIebwWhK4g7iEpIB2YqSNKBtwLLFYTuwOlAriBWBWYqiFzB2QeQY1mRCBC4+CGEb8YPGsrAxTm8BEgCEFCpVCqVSqVSqVQqnpBsSN6S/MU8+JFak2hQC58j2ZqgpAoi+QvAlVR5AeiUUl9SB3HIPxKFkFwjb/EBoM0xE7wzgGQD4Nk/lGhklQkSGfBNoIyYZJUJEgZ8EihDEpuzOysTvEg5tDnGEFNr+fXlmxBSTBf24joPE0KK6cJBbOWbEFJMF47EV7YJIcV04USM5ZoQUkwXJuIs04SQYrpgiLU8E0KK6YJFvGWZEFJMFyxjLseEkGK6MCPuMkwIKaYLM2NfvgkhxXTBIf5lmxBSTBcc27BcE0KK6YJHO5ZpQkgxXfBsy/JMCCmmCwLtWZYJIcV0QahN0UyQeCcs0mgplFIiMz1ItgCMAvvWJzIrokSUUh3sXm96UQ2YIIYJ1QADgwn/hSr/XaiCU5Fbn2SiZkBiqgGJqQYkphqQmGpAYqoBiakGJKYakJhqQGKqAYmpBiSmuGdBQmwBPO397ZRST/tfIHkF4MK3ouJeyHjwE8ADgAel1C5WpeeeAS8A1tArJ/sUAZyrAaPw65hn+zHO0YBHAG2qM/6QcxsFfVdKrXIRHzifDHgBsDocyeTAOWTAFsBVjuID5WfAFvrMn93RDuP8TwBWABr8vRnJE4AewAbAo6vBJd8HvABo5ohPvfHINYAWWvQ59AA6APdR+xjpqYWCWG+fQ/KCsptN3ZL0vku2DT5HrHdwIfmZ5J8AMfwh+Tmk9mMDcmMzI/YYW6zdBpQ/OwN21NdxU8wXJH9EjOvkJN/ShqFryw7wFrqjjcXJ/YlKGgVZjXqo97f7Giekv7hTSr3pn0rKAOODNepOMZX4APCVBx1zSRnw75QB1MPCZwi8RPFkB+ByjLWUDPhpccN1g/TiAzqGm/FDKRnwZZjHfxTmubXmpVKqLyUDHgzHW6F67iG3YqYVKSXiWPoUG4sYnwXq6fbKs11FOcUzUEYfMPkUkvqZUONZx71Sqh0/CK0da0heFW8A9ONkH96IPyJkwqoEA3rD8ZVH2UfFHxEwoQgDTBnwwbHcSfFHPE34sPhhqGmlumN8VuIf1NPCYmX9ISVkgDSzxQfcM6Ea8BYn8UdcTKgGvOIl/shcExZvAM0vYLYWxYiIPzLDhO3iDYD5Jqs3HBcVf8TShCKeBZlmP2wMx68FHiscBeZR0UbCAJsUD4mvASkRMWAjUIYPk79hM8xY+x0pljn8Vko9SRiwFijDh4bmSVBdjEBm0gECo6BhFsKdbzmemCZAdTGCmMkaEBqGDm/6U/YF11MHMzlJ9rkbX6GK/ZYkkHzKx+XUnKDhMtUDeB8roBO8mT4jOgwdMuES+myLnRGT80GHBrdxQpmkTb0uLSkk16HG/RakHrDkAckugfhd6nZnA/Xk3JgmdKnbnCWMczmql50pqBdo7AIIv2OMBRolQH1JksyGNWMtUSoJkg3JG5K9g+j98L/NnDpFb8RKgnpC1wqvy1Q/Hnxli9dlqhvXZar/A1+3j4vcx9dVAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExport);
export default __webpack_public_path__ + "static/media/import-export.1c54adc44d16c4f61555e7037d136dbc.svg";
export { ForwardRef as ReactComponent };